import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommunicationManagerService, Position } from '@ops/shared-types';

@Injectable({ providedIn: 'root' })
export class PositionService {
  constructor(
    private communicationManagerService: CommunicationManagerService
  ) {}

  public getAllPositions(): Observable<Array<Position>> {
    return this.communicationManagerService.get(`position/all`);
  }
}
